module.exports = __webpack_public_path__ + "static/media/JXVS-BNB.7dc05fff.svg";